var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewGroupChatConvWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.549,
    height: 23.541,
    viewBox: "0 0 23.549 23.541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1217",
    "data-name": "Rectangle 1217",
    width: 23.549,
    height: 23.541,
    fill: "#0d0d0d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M23.549,10.529v1.058c-.013.051-.028.1-.04.153a8.53,8.53,0,0,1-.363,1.51,2.051,2.051,0,0,0-.064,1.56c.185.556.314,1.13.467,1.7V16.6c-.858,0-1.716-.005-2.575,0a.767.767,0,0,0-.4.124,6.825,6.825,0,0,1-5.269,1.117c-.507-.1-1-.271-1.505-.412-.027.149-.056.322-.089.495A6.837,6.837,0,0,1,3.308,22.445a1.935,1.935,0,0,0-1.169-.335c-.7.024-1.408.007-2.13.007.207-.814.417-1.6.606-2.4a.778.778,0,0,0-.036-.455,6.581,6.581,0,0,1,.337-6.049,17.58,17.58,0,0,1,1.051-1.5c-.032-.035-.1-.1-.153-.169A6.545,6.545,0,0,1,.436,4.7,2.109,2.109,0,0,0,.489,3.279C.3,2.676.17,2.056.009,1.425c.876,0,1.726,0,2.576-.006a.741.741,0,0,0,.4-.124A7.062,7.062,0,0,1,5.256.23C5.632.135,6.017.075,6.4,0H7.5a1.372,1.372,0,0,0,.153.039,6.845,6.845,0,0,1,5.737,4.445c.055.131.1.266.154.407.076-.03.133-.05.188-.075a6.929,6.929,0,0,1,9.54,4.37c.123.439.185.9.275,1.343M1.787,20.737c.422,0,.82.011,1.217,0a.73.73,0,0,1,.518.182,5.456,5.456,0,0,0,3.131,1.238,5.537,5.537,0,0,0,5.75-6.359,5.272,5.272,0,0,0-3.695-4.409,5.312,5.312,0,0,0-5.617,1.254,5.321,5.321,0,0,0-1.073,6.425.7.7,0,0,1,.057.566c-.105.358-.189.723-.288,1.107m19.98-5.518c-.1-.4-.188-.785-.3-1.158a.6.6,0,0,1,.053-.479,5.323,5.323,0,0,0,.546-3.56,5.546,5.546,0,0,0-10.95.463.907.907,0,0,0,.339.919,6.6,6.6,0,0,1,2.307,4.187.449.449,0,0,0,.273.375,5.545,5.545,0,0,0,6.063-.608.714.714,0,0,1,.39-.133c.412-.016.826-.006,1.277-.006M9.744,10.281c.015-.07.03-.129.039-.189A6.8,6.8,0,0,1,12.2,5.786a.232.232,0,0,0,.082-.275,5.612,5.612,0,0,0-5.139-4.13A5.5,5.5,0,0,0,3.491,2.649a.647.647,0,0,1-.456.159c-.409-.012-.818,0-1.247,0,.107.42.216.8.295,1.191a.676.676,0,0,1-.042.408,5.512,5.512,0,0,0-.2,4.627,5.212,5.212,0,0,0,1.229,1.833,7.019,7.019,0,0,1,6.67-.583",
    transform: "translate(0 0)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 1.353,
    height: 1.349,
    transform: "translate(3.516 15.923)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1213",
    "data-name": "Rectangle 1213",
    width: 1.351,
    height: 1.352,
    transform: "translate(6.278 15.925)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1214",
    "data-name": "Rectangle 1214",
    width: 1.349,
    height: 1.353,
    transform: "translate(9.036 15.925)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1215",
    "data-name": "Rectangle 1215",
    width: 4.108,
    height: 1.354,
    transform: "translate(14.55 9.023)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1216",
    "data-name": "Rectangle 1216",
    width: 4.109,
    height: 1.351,
    transform: "translate(14.547 11.783)",
    fill: "#0d0d0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGroupChatConvWhiteIcon);
export default __webpack_public_path__ + "static/media/new-group-chat-conv-white-icon.efd0ae06177a6a961e9f2615728ea141.svg";
export { ForwardRef as ReactComponent };